import React, { memo } from 'react';

const CalendarIcon = ({ color = '#335B70', ...props }) => (
    <svg {...props} viewBox="0 0 32 32">
        <path
            fill={color}
            d="M24 14.4h-16v3.2h16v-3.2zM27.2 3.2h-1.6v-3.2h-3.2v3.2h-12.8v-3.2h-3.2v3.2h-1.6c-1.776 0-3.184 1.44-3.184 3.2l-0.016 22.4c0 1.76 1.424 3.2 3.2 3.2h22.4c1.76 0 3.2-1.44 3.2-3.2v-22.4c0-1.76-1.44-3.2-3.2-3.2zM27.2 28.8h-22.4v-17.6h22.4v17.6zM24 20.8h-16v3.2h16v-3.2z"
        />
    </svg>
);

export default memo(CalendarIcon);
